exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".styles__container___1HDG6 {\n  position: relative;\n}\n.styles__container___1HDG6.styles__fluid___1PlFs {\n  width: 100%;\n}\n.styles__container___1HDG6 .styles__content___yPU1E {\n  position: absolute;\n  top: calc(100% + 15px);\n  left: 0;\n  z-index: 3;\n  min-width: 95px;\n}\n.styles__container___1HDG6 .styles__content___yPU1E.styles__width_md___1bOtU {\n  min-width: 200px;\n}\n.styles__container___1HDG6 .styles__content___yPU1E.styles__width_block___thns1 {\n  width: 100%;\n}\n.styles__container___1HDG6 .styles__content___yPU1E .styles__wrapper___12uOd {\n  border-radius: 3px;\n  background-color: #fff;\n  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.08);\n  border: solid 1px #c0c8ce;\n  padding: 15px;\n}\n.styles__container___1HDG6 .styles__content___yPU1E .styles__wrapper___12uOd.styles__tight___1QhQ0 {\n  padding: 10px;\n}\n.styles__container___1HDG6 .styles__content___yPU1E.styles__content_bottom___kYyni {\n  top: auto;\n  bottom: 100%;\n}\n.styles__container___1HDG6 .styles__content___yPU1E.styles__content_right___1I25J {\n  left: auto;\n  right: 0;\n  text-align: right;\n}\n.styles__container___1HDG6 .styles__content___yPU1E ul {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n", ""]);

// exports
exports.locals = {
	"container": "styles__container___1HDG6",
	"fluid": "styles__fluid___1PlFs",
	"content": "styles__content___yPU1E",
	"width_md": "styles__width_md___1bOtU",
	"width_block": "styles__width_block___thns1",
	"wrapper": "styles__wrapper___12uOd",
	"tight": "styles__tight___1QhQ0",
	"content_bottom": "styles__content_bottom___kYyni",
	"content_right": "styles__content_right___1I25J"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./node_modules/stylus-loader!./src/components/shared/Dropdown/styles.styl
// module id = 344
// module chunks = 0